/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MerchantType = {
    VIRTUAL_SHOP: 'VIRTUAL_SHOP',
    CREATOR_SHOP: 'CREATOR_SHOP',
    BRAND_SHOP: 'BRAND_SHOP',
    PRIZE_STORE: 'PRIZE_STORE',
    PARTNER_ORDERING: 'PARTNER_ORDERING',
    EXTERNAL_SHOPIFY: 'EXTERNAL_SHOPIFY',
    EXTERNAL_FOURTHWALL: 'EXTERNAL_FOURTHWALL',
    EXTERNAL_WOOCOMMERCE: 'EXTERNAL_WOOCOMMERCE',
    EXTERNAL_ETSY: 'EXTERNAL_ETSY',
    RESTAURANT: 'RESTAURANT',
    GROCERY: 'GROCERY',
    CONVENIENCE: 'CONVENIENCE'
} as const;
export type MerchantType = typeof MerchantType[keyof typeof MerchantType];


export function instanceOfMerchantType(value: any): boolean {
    for (const key in MerchantType) {
        if (Object.prototype.hasOwnProperty.call(MerchantType, key)) {
            if (MerchantType[key as keyof typeof MerchantType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MerchantTypeFromJSON(json: any): MerchantType {
    return MerchantTypeFromJSONTyped(json, false);
}

export function MerchantTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MerchantType {
    return json as MerchantType;
}

export function MerchantTypeToJSON(value?: MerchantType | null): any {
    return value as any;
}

export function MerchantTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): MerchantType {
    return value as MerchantType;
}

